import React from "react";
import WindowedSelect, { WindowedMenuList } from "react-windowed-select";
import CreatableSelect from "react-select/creatable";
import { components, createFilter } from "react-windowed-select";
import { CgSpinner } from "react-icons/cg";

export const Autocomplete = ({
	onChange,
	onInputChange,
	options,
	isMulti,
	value,
	classes,
	closeMenuOnSelect,
	disabled,
	placeholder,
	isClearable,
	isLoading,
	allowCreate,
	createLabel,
	createLabelPosition,
	maxMenuHeight,
}) => {
	const c = classes || "";
	const styles = {
		control: (css, { isDisabled }) => ({
			...css,
			cursor: isDisabled ? "default" : "pointer",
		}),
		option: (css, { isDisabled }) => ({
			...css,
			cursor: isDisabled ? "default" : "pointer",
		}),
	};

	const CustomOption = ({ children, ...props }) => {
		// eslint-disable-next-line no-unused-vars
		const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
		const newProps = { ...props, innerProps: rest };
		return (
			<components.Option {...newProps} className="custom-autocomplete-option">
				{children}
			</components.Option>
		);
	};

	const customFilter = createFilter({ ignoreAccents: false });

	const formatCreateLabel = (value) => {
		const label = createLabel || "Create";
		const position = createLabelPosition || "left";

		if (position === "left") {
			return (
				<>
					<span className="font-bold">{label}</span> {value}
				</>
			);
		} else {
			return (
				<>
					{value} <span className="font-bold">{label}</span>
				</>
			);
		}
	};

	const formatOptionLabel = (option) => {
		if (Array.isArray(option.label)) {
			const l = option.label.map((o, index) => {
				return (
					<div
						key={`option_${index}`}
						className={`w-full block ${index > 0 ? "italic text-sm" : ""}`}
					>
						{o}
					</div>
				);
			});

			return <>{l}</>;
		} else {
			return <>{option.label}</>;
		}
	};

	const creatableOptions = () => {
		let _options = options ? [...options] : [];

		if (value) {
			let found = false;
			for (const o of _options) {
				if (o.label === value.label) {
					found = true;
					break;
				}
			}

			if (!found) {
				_options = [{ value: value.label, label: value.label }].concat(
					_options
				);
			}
		}

		return _options;
	};

	if (isLoading) {
		return (
			<div className={`${c} flex flex-col items-center`}>
				<CgSpinner className={"text-3xl animate-spin mb-3"} />
				<span className={"text-sm opacity-75"}>Loading...</span>
			</div>
		);
	}

	if (allowCreate) {
		const _options = creatableOptions();
		return (
			<CreatableSelect
				styles={styles}
				className={`${c} cursor-pointer`}
				closeMenuOnSelect={closeMenuOnSelect == null ? true : closeMenuOnSelect}
				value={value}
				isMulti={isMulti}
				options={_options}
				onChange={onChange}
				onInputChange={onInputChange}
				isDisabled={disabled}
				placeholder={placeholder || "Select..."}
				isClearable={isClearable}
				formatOptionLabel={formatOptionLabel}
				formatCreateLabel={formatCreateLabel}
				menuPlacement="auto"
				filterOption={customFilter}
				classNamePrefix="custom-autocomplete-select"
				components={{ MenuList: WindowedMenuList, Option: CustomOption }}
			/>
		);
	} else {
		return (
			<WindowedSelect
				styles={styles}
				className={`${c} cursor-pointer`}
				closeMenuOnSelect={closeMenuOnSelect == null ? true : closeMenuOnSelect}
				value={value}
				isMulti={isMulti}
				options={options}
				onChange={onChange}
				onInputChange={onInputChange}
				isDisabled={disabled}
				placeholder={placeholder || "Select..."}
				isClearable={isClearable}
				formatOptionLabel={formatOptionLabel}
				menuPlacement="auto"
				filterOption={customFilter}
				classNamePrefix="custom-autocomplete-select"
				components={{ Option: CustomOption }}
			/>
		);
	}
};
